import React from 'react'

import style from './style.module.css';

function index() {
    return (
        <div className={style}>
            <h1>UNKNOW PAGE X.X</h1>
        </ div>
    )
}

export default index